import { TieredMenuDesignTokens } from '@primeuix/themes/types/tieredmenu';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tFlat, t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tieredmenu/index.ts
const tm = componentCommon.tieredmenu;

export const TieredMenuTelekomDT: TieredMenuDesignTokens = {
  root: {
    color: t(tm.color),
    borderColor: t(tm.border.color),
  },
  item: tFlat(tm.item),
};
